import i18next from 'i18next';
import ky from 'ky';

import { getRelaxiApiEndpoint } from '@/constants/env';

import type { RelaxiAcceptedRequirement, RelaxiRegistrationObligations } from './types';

const publicApiPrefix = 'api/v1/public';

export const getLegalLocale = () => i18next.language || navigator.language || 'ru-RU';

export const getDocumentVersionUrl = (versionId: string, locale?: string) => {
  const url = new URL(
    `${publicApiPrefix}/legal/document-versions/${versionId}/file`,
    `${getRelaxiApiEndpoint()}/`
  );

  if (locale) {
    url.searchParams.set('locale', locale);
  }

  return url.toString();
};

const getApi = () => {
  const prefixUrl = getRelaxiApiEndpoint();

  return ky.create({
    prefixUrl,
    credentials: 'omit',
    hooks: {
      beforeRequest: [
        (request) => {
          request.headers.set(
            'Accept-Language',
            navigator.languages.join(',') || navigator.language || 'ru-RU'
          );
        },
      ],
    },
  });
};

export const getRegistrationObligations = async (locale = getLegalLocale()) =>
  getApi()
    .post(`${publicApiPrefix}/legal/registration-obligations`, {
      json: {
        locale,
      },
    })
    .json<RelaxiRegistrationObligations>();

export const precommitRegistration = async (
  sessionId: string,
  acceptedRequirements: RelaxiAcceptedRequirement[],
  identifier: { type: 'email' | 'phone'; value: string }
) =>
  getApi()
    .patch(`${publicApiPrefix}/legal/registration-sessions/${sessionId}`, {
      json: {
        acceptedRequirements,
        identifier,
      },
    })
    .json<{ expiresAt: string }>();
